import React from 'react';

const NotFound = () => (
  <div className="vh-100 p-3 d-flex justify-content-center align-items-center">
    <div className="text-center pb-5">
      <h1 className="display-1">404</h1>
      <h4 className="display-4">Page not found</h4>
    </div>
  </div>
);

export default NotFound;
